import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import { uiMapper } from "@/services/store/modules/ui/store";
import { dataMapper } from "../services/store/modules/data/store";
// import sleep from '@/mixins/sleep'
import RowBack from "@/components/RowBack.vue";
import ButtonApp from "@/components/ButtonApp.vue";
const UiMappers = Vue.extend({
    methods: {
        ...uiMapper.mapMutations(["closeFormCall", "openFormCall", "openFormPay"]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(["courses"]),
        ...dataMapper.mapGetters(["formMail"]),
    },
    methods: {
        ...dataMapper.mapMutations([
            "setFormCallTitle",
            "setFormCallScreen",
            "deactivateFormField",
            "clearForm",
        ]),
    },
});
let PageCourse = class PageCourse extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        // @Prop() item: object
        this.ps = null;
    }
    get activeId() {
        return this.$route.params.id;
    }
    get activeItem() {
        return this.courses.find((course) => course.id === Number(this.activeId) || course.titleEng === this.activeId);
    }
    get formCallMail() {
        return this.formMail("callback");
    }
    async mounted() {
        document.body.classList.add("modal-open");
        // await this.$nextTick()
        // this.initScrollbar()
        // await this.$nextTick()
        // if (this.ps) this.ps.update()
    }
    destroyed() {
        document.body.classList.remove("modal-open");
        // this.destroyScrollbar()
    }
    initScrollbar() {
        // this.ps = new PerfectScrollbar('#container-hds729-js')
    }
    destroyScrollbar() {
        if (this.ps) {
            this.ps.destroy();
            this.ps = null;
        }
    }
    onCloseClick() {
        // @ts-ignore
        this.$router.push({ path: "/" }).catch(() => { });
    }
    async onOpenFormClick() {
        this.clearForm("callback");
        await this.$nextTick();
        this.setFormCallTitle(`Забронировать место в смене ${this.activeItem.title}`);
        this.setFormCallScreen("Страница Подробнее");
        this.deactivateFormField(this.formCallMail);
        this.openFormCall();
    }
};
PageCourse = __decorate([
    Component({
        components: {
            RowBack,
            ButtonApp,
        },
    })
], PageCourse);
export default PageCourse;
